import { getItemFromCollection } from "directus/src/operations";

export async function fetchToolData({ toolId }) {
  try {
    const response = await getItemFromCollection("tools", toolId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
